import { Helmet } from "react-helmet-async";
import { Hero } from "@/src/components/Hero";
import { About } from "@/src/components/About";
import { CoachingPhilosophy } from "@/src/components/CoachingPhilosophy";
import { FeaturedVideo } from "@/src/components/FeaturedVideo";
import { Services } from "@/src/components/Services";
import { Testimonials } from "@/src/components/Testimonials";
import { Contact } from "@/src/components/Contact";

export function Home() {
  return (
    <>
      <Helmet>
        <title>Iwantcoaching | Strengthsfinder Coaching & Career Guidance Pretoria</title>
        <meta name="description" content="Based in Pretoria, South-Africa, Iwantcoaching focuses on Strengthsfinder coaching and career guidance. Accredited specialists in individual and group coaching." />
        <meta name="keywords" content="Strengthsfinder coaching, career guidance, Pretoria, South Africa, talent discovery, personal development, executive coaching" />
        <meta name="geo.region" content="ZA-GP" />
        <meta name="geo.placename" content="Pretoria" />
        <meta name="geo.position" content="-25.7831;28.2522" />
        <meta name="ICBM" content="-25.7831, 28.2522" />
        <link rel="canonical" href="https://iwantcoaching.co.za/" />
      </Helmet>
      <Hero />
      <About />
      <CoachingPhilosophy />
      <FeaturedVideo />
      <Services />
      <Testimonials />
      <Contact />
    </>
  );
}
